//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import cloneDeep from 'lodash/fp/cloneDeep';
import photoEditorConfig from './photo-editor-config';

const instagramConfig = cloneDeep(photoEditorConfig);

// This is a instagram specific version of the beautify config which includes a story post crop and
// specific language around what crops are auto-post eligible for instagram.
instagramConfig.editor.controlsOptions = {
  transform: {
    availableRatios: [
      'imgly_transform_common_custom',
      'imgly_transform_custom_square',
      'imgly_transform_common_4-5',
      'imgly_transform_common_9-16',
      'imgly_transform_common_16-9',
      'imgly_transform_common_4-3',
      'imgly_transform_common_5-4',
    ],
    ratios: [
      {
        identifier: 'imgly_transform_custom_square',
        defaultName: 'Square\n(Auto-Post Eligible)',
        ratio: 1,
      },
      {
        identifier: 'imgly_transform_common_4-5', // A unique identifier for this ratio
        defaultName: '4:5\n(Auto-Post Eligible)', // The default translation for this ratio
        ratio: 4 / 5, // The image ratio (a floating point number)
      },
      {
        identifier: 'imgly_transform_common_9-16',
        defaultName: '9:16 IG Story',
        ratio: 9 / 16,
      },
      {
        identifier: 'imgly_transform_common_5-4',
        defaultName: '5:4\n(Auto-Post Eligible)',
        ratio: 5 / 4,
      },
    ],
  },
};
export default instagramConfig;
